import { useState, useRef } from 'react';
import './Contact.css'; // Reusing contact styles
import { appCheck } from '../firebase';
import '../pages/Services/Services.css';

const Unsubscribe = () => {
    const form = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            // Get App Check token which uses reCAPTCHA v3
            const appCheckTokenResponse = await appCheck.getToken();

            const response = await fetch('https://api.sradhatech.com/api/unsubscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Firebase-AppCheck': appCheckTokenResponse.token,
                    'Authorization': 'Bearer ' + appCheckTokenResponse.token
                },
                body: JSON.stringify({
                    name: e.target.name.value,
                    email: e.target.email.value,
                    phone: e.target.phone.value,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setSubmitStatus('Successfully unsubscribed from SradhaTech, no further messages will be sent.');
                e.target.reset();
            } else {
                throw new Error(data.error || 'Failed to unsubscribe');
            }
        } catch (error) {
            setSubmitStatus(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            <div className="service-header">
                <h1>Unsubscribe</h1>
                <p>Opt-out of further SMS messages and communications</p>
            </div>

            <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="contact-container" style={{ width: '100%', maxWidth: '800px' }}>
                    <div className="contact-form-container" style={{ width: '100%', padding: '0' }}>
                        <form ref={form} onSubmit={handleSubmit} className="contact-form">
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    required
                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9+]/g, ''); }}
                                />
                            </div>

                            {submitStatus && (
                                <div className={`submit-status ${submitStatus.includes('Successfully') ? 'success' : 'error'}`}>
                                    {submitStatus}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="submit-btn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Processing...' : 'Unsubscribe'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Unsubscribe;
